import { render, staticRenderFns } from "./CardAuthorTable.vue?vue&type=template&id=dec74a3c&scoped=true"
import script from "./CardAuthorTable.vue?vue&type=script&lang=js"
export * from "./CardAuthorTable.vue?vue&type=script&lang=js"
import style0 from "./CardAuthorTable.vue?vue&type=style&index=0&id=dec74a3c&prod&lang=css&scoped=true"
import style1 from "./CardAuthorTable.vue?vue&type=style&index=1&id=dec74a3c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dec74a3c",
  null
  
)

export default component.exports